export * from "./use-favorites-resource";
